/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultReferentialCategory } from '../../models/api-response-paged-result-referential-category';
import { PagedRequestReferentialCategory } from '../../models/paged-request-referential-category';

export interface SearchReferentialCatgory$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestReferentialCategory
}

export function searchReferentialCatgory(http: HttpClient, rootUrl: string, params: SearchReferentialCatgory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialCategory>> {
  const rb = new RequestBuilder(rootUrl, searchReferentialCatgory.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultReferentialCategory>;
    })
  );
}

searchReferentialCatgory.PATH = '/v1/api/ui/referential/category/search';
